<template>
  <div class="upload-image-box">
    <template v-if="imageList && imageList.length > 0">
      <div class="upload-li" v-for="(item, index) in imageList" :key="index">
        <i
          v-if="!disabled"
          class="el-icon-circle-cross"
          @click="deleteCurrent(index)"
        ></i>
        <div class="cover">
          <img :src="item.url" alt="" />
        </div>
      </div>
    </template>
    <div
      v-if="imageList.length < maxLength && !disabled"
      class="upload-li-add"
      @click="handleAdd"
    >
      <img
        class="upload-li-add-icon"
        src="https://o.666visa.cn/static/ssqwxa/upload-static/upload-camera.png"
        alt=""
      />
      <div class="add-text">添加图片</div>
    </div>
  </div>
</template>

<script>
import fileService from '@/services/file-service.js';
import uploadFileService from '@/services/upload-file-service.js';

const ACCEPT_FILE_TYPE = 'image/jpeg,image/png';

export default {
  data() {
    return {
      tempFileList: null,
    };
  },
  props: {
    imageList: {
      type: Array,
      value: [],
    },
    // 上传图片大小
    size: {
      type: Number,
      value: 5 * 1024 * 1024,
    },
    maxLength: {
      type: Number,
      value: 6,
    },
    disabled: {
      type: Boolean,
      value: false,
    },
  },
  methods: {
    deleteCurrent(index) {
      this.$emit('delete', index);
    },
    async handleAdd() {
      const tempFiles = await fileService.chooseFile({
        multiple: true,
        checkInfo: this.size,
        accept: ACCEPT_FILE_TYPE,
      });

      if (this.imageList.length + tempFiles.length > this.maxLength) {
        this.$message.error('最多上传6个文件');
        return;
      }

      // const suffix = tempFiles.map(item => item.type);
      // const isCorrectSuffix = suffix.every(item => ['image/jpeg', 'image/jpg', 'image/png'].includes(item));
      // if (!isCorrectSuffix) {
      //   this.$message.error('上传文件格式错误');
      //   return;
      // }

      Promise.all(
        tempFiles.map(file =>
          uploadFileService
            .uploadFileWithOssout(file, false, { noKey: true })
            .then((res) => {
              const url = `https://${res.oss_out}/${res.key}`;
              this.$emit('add', { url });
            }),
        ),
      ).finally(() => {});
    },
  },
};
</script>
<style lang="less">
.upload-image-box {
  width: 100%;
  display: flex;
  justify-content: flex;
  flex-wrap: wrap;
  .upload-li,
  .upload-li-add {
    width: 88px;
    height: 88px;
    border-radius: 4px;
    background: #fbfbfb;
    margin: 0 16px 16px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .cover {
      width: 88px;
      height: 88px;
      overflow: hidden;
      > img {
        object-fit: contain;
        width: 100%;
        height: 100%;
      }
    }
    .upload-li-add-icon {
      width: 32px;
      height: 32px;
    }
    .add-text {
      font-size: 14px;
      color: #999;
      margin-top: 6px;
    }
    &:hover {
      cursor: pointer;
    }
  }
  .upload-li {
    position: relative;
    > i {
      display: none;
    }
    &:hover {
      > i {
        display: block;
        position: absolute;
        right: -6px;
        top: -6px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/upload/upload-image.vue